import type { FacilityId } from '../ranch/economy';
import type { MinigameDef, MinigameId } from './framework';
import { GALLOP_DEF } from './gallop';
import { GATES_DEF } from './gates';
import { PEN_DEF } from './pen';
import { TRAIL_DEF } from './trail';
import { FURLONGS_DEF } from './furlongs';
import { POLES_DEF } from './poles';
import { HILLS_DEF } from './hills';
import { TEMPO_DEF } from './tempo';
import { FLYING_START_DEF } from './flying-start';
import { GEARS_DEF } from './gears';
import { DESENSITIZE_DEF } from './desensitize';
import { TRUST_DEF } from './trust';

export const MINIGAMES: Record<MinigameId, MinigameDef> = {
  gallop: GALLOP_DEF,
  furlongs: FURLONGS_DEF,
  poles: POLES_DEF,
  trail: TRAIL_DEF,
  hills: HILLS_DEF,
  tempo: TEMPO_DEF,
  gates: GATES_DEF,
  flyingStart: FLYING_START_DEF,
  gears: GEARS_DEF,
  pen: PEN_DEF,
  desensitize: DESENSITIZE_DEF,
  trust: TRUST_DEF,
};

export const MINIGAMES_FOR_FACILITY: Record<FacilityId, readonly [MinigameId, MinigameId, MinigameId]> = {
  gallopTrack: ['gallop', 'furlongs', 'poles'],
  enduranceTrail: ['trail', 'hills', 'tempo'],
  startingGate: ['gates', 'flyingStart', 'gears'],
  roundPen: ['pen', 'desensitize', 'trust'],
};

/** Legacy single-mode lookup retained for old command tapes. New play
 * always uses the rotating three-mode list above. */
export const MINIGAME_FOR_FACILITY: Record<FacilityId, MinigameId> = {
  gallopTrack: 'gallop',
  enduranceTrail: 'trail',
  startingGate: 'gates',
  roundPen: 'pen',
};

export function facilityForMinigame(minigame: MinigameId): FacilityId {
  for (const [facility, modes] of Object.entries(MINIGAMES_FOR_FACILITY)) {
    if ((modes as readonly MinigameId[]).includes(minigame)) return facility as FacilityId;
  }
  return 'gallopTrack';
}

export const MINIGAME_IDS: readonly MinigameId[] = [
  'gallop', 'furlongs', 'poles',
  'trail', 'hills', 'tempo',
  'gates', 'flyingStart', 'gears',
  'pen', 'desensitize', 'trust',
];

export function isMinigameId(value: unknown): value is MinigameId {
  return typeof value === 'string' && (MINIGAME_IDS as readonly string[]).includes(value);
}
